<script lang="ts">
  let props = $props()
  let user = props.user
</script>

<p class="text-xs text-gray-700">
  {#if user.role == "admin"}
    Plan Admin
  {:else if user.role === "leader"}
    Leadership Team
  {:else if user.role === "manager"}
    Management Team
  {:else if user.role === "member"}
    Limited Access
  {:else if user.role === "recognition"}
    Recognition-Only
  {/if}
</p>
